import React from 'react';
import { whyUs } from '../data/services';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';

export default function WhyUs() {
  return (
    <section className="section">
      <div className="container">
        <Reveal><h2 className="bigh">Why Choose<br />Sheba Digital</h2></Reveal>
        <Reveal delay={80} className="prose prose--wide">
          <p>Engineering discipline, business understanding and a commitment that does not end at deployment. Here is what clients can expect when they build with us.</p>
        </Reveal>
        <div className="whyrow">
          {whyUs.map((w, i) => (
            <Reveal key={w.title} delay={(i % 5) * 70} className="whyrow__item">
              <Icon name={w.icon} size={40} />
              <h3>{w.title}</h3>
              <p>{w.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
